import { createPortal } from 'react-dom'

export function PhosphorIconsScript() {
  return createPortal(
    <>
      <link
        rel="stylesheet"
        type="text/css"
        data-transition-keep={JSON.stringify({ id: 'phosphor-regular' })}
        href="https://unpkg.com/@phosphor-icons/web@2.1.1/src/regular/style.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        data-transition-keep={JSON.stringify({ id: 'phosphor-thin' })}
        href="https://unpkg.com/@phosphor-icons/web@2.1.1/src/thin/style.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        data-transition-keep={JSON.stringify({ id: 'phosphor-light' })}
        href="https://unpkg.com/@phosphor-icons/web@2.1.1/src/light/style.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        data-transition-keep={JSON.stringify({ id: 'phosphor-bold' })}
        href="https://unpkg.com/@phosphor-icons/web@2.1.1/src/bold/style.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        data-transition-keep={JSON.stringify({ id: 'phosphor-fill' })}
        href="https://unpkg.com/@phosphor-icons/web@2.1.1/src/fill/style.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        data-transition-keep={JSON.stringify({ id: 'phosphor-duotone' })}
        href="https://unpkg.com/@phosphor-icons/web@2.1.1/src/duotone/style.css"
      />
    </>,
    document.head,
  )
}
